import { createAction, props } from '@ngrx/store';
import { Domain } from 'src/app/shared/services/api/bulk-assessments/bulk-assessment.service';

export const setSelectedDomain = createAction(
  '[Bulk Assessment] Set Selected Domain',
  props<{ domain: Domain }>()
);

export const setBulkAssessmentContext = createAction(
  '[Bulk Assessment] Set Context',
  props<{
    classId: number;
    standard: string;
    assessmentPeriodId: number;
    targetedLang: string;
  }>()
);

export const clearBulkAssessment = createAction(
  '[Bulk Assessment] Clear'
);
